const initialState = {};

function auth(state = initialState, action) {
  switch (action.type) {
    case "CURRENT_USER":
      return {
        user: action.user,
        isAuthenticated: true,
        isAdmin: action.user.isAdmin
      };
    case "LOGOUT":
      return {
        user: null,
        isAuthenticated: false
      };
    default:
      return state
  }
}

export {auth};



// WEBPACK FOOTER //
// ./reducers/auth.js